import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CourseService } from '@/services';
import type { ChapterItemType, ChapterType, UserCourseStatus } from '@/types';

export function useChapter(
  isSessionLoaded: boolean,
  courseId?: string,
  chapterId?: string,
  type?: ChapterItemType,
) {
  return useQuery({
    queryKey: ['chapters', type?.toLowerCase(), chapterId],
    queryFn: async () =>
      CourseService.getChapter(courseId ?? '', chapterId ?? '', type ?? 'Exercise'),
    enabled: isSessionLoaded && !!courseId && !!chapterId && !!type,
  });
}

export function useChapterCompleted() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      courseId,
      chapterId,
      chapterType,
    }: {
      courseId: string;
      chapterId: string;
      chapterType: ChapterType;
    }) => CourseService.toggleChapterComplete(courseId, chapterId, chapterType),
    onSuccess: (status) => queryClient.setQueryData<UserCourseStatus>(['userCourseStatus'], status),
  });
}
